import { render, staticRenderFns } from "./RuleGoList.vue?vue&type=template&id=dbca0bbc"
import script from "./RuleGoList.vue?vue&type=script&lang=js"
export * from "./RuleGoList.vue?vue&type=script&lang=js"
import style0 from "./RuleGoList.vue?vue&type=style&index=0&id=dbca0bbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports